/**
 * Authenticated fetch wrapper.
 * Automatically injects the JWT Bearer token from localStorage
 * into every request, so pages using raw fetch() get auth support.
 *
 * Usage:  import { authFetch } from '../lib/authFetch';
 *         const response = await authFetch('/api/bu-types');
 */

import { resolveApiUrl } from './apiBase';

export function authFetch(url, options = {}) {
    const token = localStorage.getItem('banyan_token');

    const normalisedUrl = resolveApiUrl(url);

    const headers = { ...(options.headers || {}) };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(normalisedUrl, { ...options, headers });
}

export default authFetch;
